<template>
    <div class="row justify-content-center entry">
        <div class="col-12 text-center">
            <h1 id="h1Titulo"><strong>Simulação:</strong>{{loansName}}</h1>
        </div>

        <div class="col-12 col-md-12 col-lg-8">
            <div class="row no-gutters">
                <div class="col-12 col-md-6 col-lg-6 pad">
                    <div class="bg-box text-center">
                        <div class="box box-iouu">
                            <div class="box__head">
                                <a href="/" class="link" title="IOUU">
                                    <i class="ico-iouu" />
                                </a>
                            </div>
                            <div class="box__finance">
                                <p>Valor financiado</p>
                                <strong class="valorFinanciado">R$ {{valor}}</strong>
                            </div>
                            <div class="box__tax">
                                <p>Juros</p>
                                <span>
                                    <span>
                                        <strong><span id="iouu_jaa">{{jurosaaIouu}}%</span> <small>a.a.</small></strong>
                                    </span>
                                    <span>
                                        <strong><span id="iouu_jam">{{jurosamIouu}}%</span> <small>a.m.</small></strong>
                                    </span>
                                </span>
                            </div>
                            <div class="box__amount">
                                <p>Total</p>
                                <strong id="iouu_t">R$ {{totalIouu}}</strong>
                            </div>
                            <div class="box__payment">
                                <div>
                                    <span class="parc">{{numeroParcelas}}</span>
                                    <span class="info">
                                        Parcelas de
                                        <strong id="iouu_vp">R$ {{parcelaIouu}}</strong>
                                    </span>
                                </div>
                            </div>
                            <div class="box__taxs">
                            <p>Taxa efetiva</p>
                                <span>
                                    <span>
                                        <strong><span id="iouu_cet_jaa">{{jurosaacet}}%</span> <small>a.a.</small></strong>
                                    </span>
                                    <span>
                                        <strong><span id="iouu_cet_jam">{{juroscetIouu}}%</span> <small>a.m.</small></strong>
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-3 col-lg-3 pad">
                    <div class="box box-compare text-center">
                        <div class="box__head">
                            <p>Cheque especial</p>
                        </div>
                        <div class="box__finance">
                            <p>Valor financiado</p>
                            <strong class="valorFinanciado">R$ {{valor}}</strong>
                        </div>
                        <div class="box__tax">
                            <p>Juros</p>
                            <span>
                                <span>
                                    <strong><span id="CS_jaa">{{jurosaaCheque}}%</span> <small>a.a.</small></strong>
                                </span>
                                <span>
                                    <strong><span id="CS_jaa">{{jurosamCheque}}%</span> <small>a.m.</small></strong>
                                </span>
                            </span>
                        </div>
                        <div class="box__amount">
                            <p>Total</p>
                            <strong id="CS_t">R$ {{totalCheque}}</strong>
                        </div>
                        <div class="box__payment">
                            <div>
                                <span class="parc">{{numeroParcelas}}</span>
                                <span class="info">
                                    Parcelas de
                                    <strong id="CS_vp">R$ {{parcelaCheque}}</strong>
                                </span>
                            </div>
                        </div>
                        <div class="box__taxs">
                            <p>Taxa efetiva</p>
                            <span>
                                <span>
                                    <strong><span id="CS_cet_jaa">368,79%</span> <small>a.a.</small></strong>
                                </span>
                                <span>
                                    <strong><span id="CS_cet_jam">13,54%</span> <small>a.m.</small></strong>
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-3 col-lg-3 pad">
                    <div class="box box-compare text-center">
                        <div class="box__head">
                            <p>Cartão de crédito</p>
                        </div>
                        <div class="box__finance">
                            <p>Valor financiado</p>
                            <strong class="valorFinanciado">R$ {{valor}}</strong>
                        </div>
                        <div class="box__tax">
                            <p>Juros</p>
                            <span>
                                <span>
                                    <strong><span id="CC_jaa">{{jurosaaCartao}}%</span> <small>a.a.</small></strong>
                                </span>
                                <span>
                                    <strong><span id="CC_jam">{{jurosamCartao}}%</span> <small>a.m.</small></strong>
                                </span>
                            </span>
                        </div>
                        <div class="box__amount">
                            <p>Total</p>
                            <strong id="CC_t">R$ {{totalCartao}}</strong>
                        </div>
                        <div class="box__payment">
                            <div>
                                <span class="parc">{{numeroParcelas}}</span>
                                <span class="info">
                                    Parcelas de
                                    <strong id="CC_vp">R$ {{parcelaCartao}}</strong>
                                </span>
                            </div>
                        </div>
                        <div class="box__taxs">
                            <p>Taxa efetiva</p>
                            <span>
                                <span>
                                    <strong><span id="CC_cet_jaa">250,40%</span> <small>a.a.</small></strong>
                                </span>
                                <span>
                                    <strong><span id="CC_cet_jam">10,85%</span> <small>a.m.</small></strong>
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 text-center obs">
                    <p>
                        Valores sujeitos à análise de crédito. Para valores exatos crie uma proposta.<br>
                        CET corresponde ao índice que engloba todos os encargos, tributos, taxas e despesas
                    </p>
                    <router-link :to="`/tipo-de-emprestimo/simulacao?type=${this.type}`" class="btn btn-link">Nova simulação</router-link>
                    <router-link :to="`/tipo-de-emprestimo/solicitar-emprestimo?type=${this.type}`" class="btn btn-lg btn-primary">Crie sua proposta</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        metaInfo: {
            htmlAttrs: {
                lang: 'pt-br'
            },
            bodyAttrs: {
                class: 'simulacao'
            }
        },
        data() {
            return {
                type: this.$route.query.type,
                dataSimulator: JSON.parse(localStorage.getItem('simulatorData')),
            }
        },
        computed: {
            loansName: function(){
                return this.titleTipe();
            },
            valor: function() {
                return this.currencyFormat(parseFloat(localStorage.getItem('loansValue')));
            },
            numeroParcelas: function() {
                return this.dataSimulator.n;
            },
            parcelaIouu: function(){
                return this.currencyFormat(this.dataSimulator.parcelas);
            },
            totalIouu: function(){
                return this.currencyFormat(this.dataSimulator.total);
            },
            jurosamIouu: function() {
                return this.currencyFormat(this.dataSimulator.juros);
            },
            jurosaaIouu: function() {
                return this.currencyFormat(this.dataSimulator.jurosaa);
            },
            juroscetIouu: function() {
                return this.currencyFormat(this.dataSimulator.juroscet);
            },
            jurosaacet: function(){
                return this.currencyFormat(this.dataSimulator.jurosaacet)
            },
            parcelaCheque: function() {
                return this.currencyFormat(this.dataSimulator.chequeparcelas);
            },
            totalCheque: function() {
                return this.currencyFormat(this.dataSimulator.chequetotal);
            },
            jurosamCheque: function() {
                return this.currencyFormat(this.dataSimulator.chequeam);
            },
            jurosaaCheque: function(){
                return this.currencyFormat(this.dataSimulator.chequeaa);
            },
            parcelaCartao: function() {
                return this.currencyFormat(this.dataSimulator.capitalparcelas);
            },
            totalCartao: function() {
                return this.currencyFormat(this.dataSimulator.capitaltotal);
            },
            jurosamCartao: function() {
                return this.currencyFormat(this.dataSimulator.capitalam);
            },
            jurosaaCartao: function() {
                return this.currencyFormat(this.dataSimulator.capitalaa);
            }
        }, 
        methods: {
            titleTipe() {
                let title;

                switch(this.type) {
                    case 'EMPPES':
                      title = ' Emprestimo Pessoal';
                      break;

                    case 'EMPVEI':
                        title = ' Veículo em Garantia';
                        break;

                    case 'EMIMB':
                        title = ' Imóvel em Garantia';
                        break;

                     case 'EMPIMP2':
                        title = ' Empréstimo de Impacto';
                        break;

                    default:
                        title = ' Emprestimo Coletivo';
                        break;
                }

                return title;
            },
            currencyFormat(num) {
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
            },
            //tagueamento GA
            taggingGA() {
                this.$ga.page({
                    page: '/tipo-de-emprestimo/simulacao-emprestimo',
                    title: 'simulacao-emprestimo',
                })
            },
        },
        beforeCreate() {
            
        },
        async created() {
            //tagueamento GA
            await this.taggingGA();
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/LoanSimulation.vue